import { render, staticRenderFns } from "./TheChallengeList.vue?vue&type=template&id=60cde5a2&"
import script from "./TheChallengeList.vue?vue&type=script&lang=js&"
export * from "./TheChallengeList.vue?vue&type=script&lang=js&"
import style0 from "./TheChallengeList.vue?vue&type=style&index=0&id=60cde5a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports